import {
    _getQuestions,
    _getUsers,
    _saveQuestion,
    _saveQuestionAnswer
} from "./_DATA";

// function returning promise for
// asychronous fetching of data
// from _DATA.js
export function getInitialData () {
    return Promise.all([
        _getUsers(),
        _getQuestions(),
    ]).then(([users, questions]) => ({
        users,
        questions,
    }));
}

export function saveQuestion (info) {
    return _saveQuestion(info);
}

export function saveQuestionAnswer (info) {
    return _saveQuestionAnswer(info);
}